/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Company_TextInputs */

const en_about_company_text = /** @type {(inputs: About_Company_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema is operated by EliteX GbR, a German company founded by Vaisakhan Arackal Sanu and Chris Zanfir. We are based in Aichach, Bavaria, Germany.`)
};

const de_about_company_text = /** @type {(inputs: About_Company_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema wird von der EliteX GbR betrieben, einem deutschen Unternehmen, gegruendet von Vaisakhan Arackal Sanu und Chris Zanfir. Unser Sitz ist in Aichach, Bayern, Deutschland.`)
};

const fr_about_company_text = /** @type {(inputs: About_Company_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema est exploité par EliteX GbR, une entreprise allemande fondée par Vaisakhan Arackal Sanu et Chris Zanfir à Aichach, en Bavière.`)
};

const es_about_company_text = /** @type {(inputs: About_Company_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema es operado por EliteX GbR, una empresa alemana fundada por Vaisakhan Arackal Sanu y Chris Zanfir, con sede en Aichach, Baviera.`)
};

const it_about_company_text = /** @type {(inputs: About_Company_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema e gestito da EliteX GbR, una societa tedesca fondata da Vaisakhan Arackal Sanu e Chris Zanfir, con sede a Aichach, Baviera.`)
};

const nl_about_company_text = /** @type {(inputs: About_Company_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema wordt beheerd door EliteX GbR, een Duits bedrijf opgericht door Vaisakhan Arackal Sanu en Chris Zanfir, gevestigd in Aichach, Beieren.`)
};

const pl_about_company_text = /** @type {(inputs: About_Company_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema jest prowadzona przez EliteX GbR, niemiecka spolke zalozona przez Vaisakhan Arackal Sanu i Chris Zanfir, z siedziba w Aichach, Bawaria.`)
};

const fi_about_company_text = /** @type {(inputs: About_Company_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchemaa ylläpitää EliteX GbR, saksalainen yhtiö, jonka perustivat Vaisakhan Arackal Sanu ja Chris Zanfir, ja jonka kotipaikka on Aichach, Baijeri.`)
};

const da_about_company_text = /** @type {(inputs: About_Company_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema drives af EliteX GbR, et tysk selskab grundlagt af Vaisakhan Arackal Sanu og Chris Zanfir, med base i Aichach, Bayern.`)
};

const sv_about_company_text = /** @type {(inputs: About_Company_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema drivs av EliteX GbR, ett tyskt foretag grundat av Vaisakhan Arackal Sanu och Chris Zanfir, med sate i Aichach, Bayern.`)
};

/**
* | output |
* | --- |
* | "Alchema is operated by EliteX GbR, a German company founded by Vaisakhan Arackal Sanu and Chris Zanfir. We are based in Aichach, Bavaria, Germany." |
*
* @param {About_Company_TextInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const about_company_text = /** @type {((inputs?: About_Company_TextInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Company_TextInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_about_company_text(inputs)
	if (locale === "fr") return fr_about_company_text(inputs)
	if (locale === "es") return es_about_company_text(inputs)
	if (locale === "it") return it_about_company_text(inputs)
	if (locale === "nl") return nl_about_company_text(inputs)
	if (locale === "pl") return pl_about_company_text(inputs)
	if (locale === "fi") return fi_about_company_text(inputs)
	if (locale === "da") return da_about_company_text(inputs)
	if (locale === "sv") return sv_about_company_text(inputs)
	return en_about_company_text(inputs)
});